/**
 * @file time/index.ts
 * @description Time service to manage all the datetimes related operations.
 *
 * @author smendonca
 *
 */

/**
 * Imports.
 */
// Modules
import moment from 'moment';

/**
 * Gets current date and time.
 * @param format Date time format to be returned.
 * @returns Current date and time.
 */
export const now = (format: string | null = null): Date | string => {
  if (format) return moment().format(format);
  return moment().toDate();
};

/**
 * returns a number representing the current date
 * @returns a number that represets the current time
 */
export const timestamp = (): number => {
  const dt = moment().local().valueOf();
  return dt;
};

/**
 * returns the iso format yyyy-mm-dd
 * @returns iso date string
 */
export const isoDate = (): string => {
  const dt = moment().local().toISOString();
  return dt;
};
